{
  "selection": {
    "title": "NEXL IA",
    "description": "Sélectionnez le contenu que vous souhaitez générer",
    "aria_label": "nexl ia"
  },
  "event_pack": {
    "title": "Pack Événement",
    "description": "Utilisez ceci pour générer une invitation d'événement pour votre courriel, publication LinkedIn et votre site web",
    "header": "Nexl IA - Pack Événement",
    "instructions": "Veuillez remplir les champs nécessaires pour un message personnalisé. Cliquez sur 'générer' pour voir votre résultat.",
    "form": {
      "start_time_label": "Heure de début",
      "start_time_placeholder": "Quand a lieu l'événement ?",
      "location_label": "Lieu",
      "location_placeholder": "Où se déroule l'événement ? ",
      "description_label": "De quoi s'agit-il l'événement ?",
      "description_placeholder": "Décrivez votre événement en quelques phrases. Quel est le but et quelles sont les caractéristiques principales ?",
      "validation": {
        "start_time_required": "Veuillez saisir une heure de début",
        "location_required": "Veuillez saisir un lieu",
        "description_required": "Veuillez saisir une description"
      }
    },
    "tabs": {
      "email": "Courriel",
      "linkedin_post": "Publication LinkedIn",
      "website": "Site web"
    }
  },
  "marketing_email": {
    "title": "Courriel Marketing",
    "description": "Utilisez ceci pour générer du contenu pour votre courriel marketing",
    "header": "Nexl IA - courriel Marketing",
    "instructions": "Veuillez remplir les champs nécessaires pour un message courriel personnalisé. Cliquez sur 'générer' pour voir votre résultat.",
    "form": {
      "description_label": "Quelles informations prévoyez-vous d'inclure ?",
      "description_placeholder": "Parlez-nous un peu du contenu que vous prévoyez d'inclure.",
      "validation": {
        "description_required": "Veuillez saisir une description"
      }
    }
  },
  "linkedin_post": {
    "title": "Publication LinkedIn",
    "description": "Utilisez ceci pour générer du contenu pour votre publication LinkedIn",
    "header": "Nexl IA - LinkedIn",
    "instructions": "Veuillez remplir les champs nécessaires pour du contenu LinkedIn personnalisé. Cliquez sur 'générer' pour voir votre résultat."
  },
  "response": {
    "waiting_message": "En attente de la réponse ChatGPT",
    "try_again_message": "Veuillez réessayer plus tard",
    "no_content_title": "Aucun Contenu Généré",
    "no_content_description": "Remplissez les champs et cliquez sur 'Générer' quand vous êtes prêt",
    "no_response_title": "Aucune Réponse Reçue"
  },
  "actions": {
    "start": "Commencer",
    "generate": "Générer"
  }
}
